/**
 * Registry of sports for clubs.
 * Add a new entry here to introduce another sport — it stays separate from Soccer and Running.
 * Backend Club.SportType must include the same id.
 */
export const CLUB_SPORTS = [
  {
    id: 'SOCCER',
    label: 'Soccer',
    shortLabel: 'Soccer',
    description: 'Clubs for practices, matches, and team splits.',
    joinCta: 'Join to play',
    guestCta: 'Join to play',
    requiresPlayerProfile: true,
    requiresRunnerProfile: false,
  },
  {
    id: 'RUNNING',
    label: 'Running',
    shortLabel: 'Running',
    description: 'Routes, gathering spots, availability votes, and practice photo sharing.',
    joinCta: 'Request to join',
    guestCta: 'Join this running club',
    requiresPlayerProfile: false,
    requiresRunnerProfile: true,
  },
  {
    id: 'HIKING',
    label: 'Hiking',
    shortLabel: 'Hiking',
    description: 'Trails, trailhead meetups, availability votes, and outing photo sharing.',
    joinCta: 'Request to join',
    guestCta: 'Join this hiking club',
    requiresPlayerProfile: false,
    requiresRunnerProfile: false,
    requiresHikerProfile: true,
  },
];

/** Legacy ids still accepted from older registrations / URLs. */
const SPORT_ALIASES = {
  CROSS_COUNTRY: 'RUNNING',
  CROSS_COUNTRY_RUN: 'RUNNING',
  XC: 'RUNNING',
  RUN: 'RUNNING',
  HIKE: 'HIKING',
  TRAIL_HIKING: 'HIKING',
};

export function listClubSports() {
  return CLUB_SPORTS;
}

export function getClubSport(sportId) {
  const normalized = normalizeClubSport(sportId);
  return CLUB_SPORTS.find((item) => item.id === normalized) || CLUB_SPORTS[0];
}

export function getClubSportLabel(sportId) {
  return getClubSport(sportId).label;
}

export function normalizeClubSport(sportId) {
  if (!sportId) return 'SOCCER';
  const normalized = String(sportId).trim().toUpperCase().replace(/[\s-]+/g, '_');
  const aliased = SPORT_ALIASES[normalized] || normalized;
  return CLUB_SPORTS.some((item) => item.id === aliased) ? aliased : 'SOCCER';
}

export function isKnownClubSport(sportId) {
  if (!sportId) return false;
  const normalized = String(sportId).trim().toUpperCase().replace(/[\s-]+/g, '_');
  const aliased = SPORT_ALIASES[normalized] || normalized;
  return CLUB_SPORTS.some((item) => item.id === aliased);
}
